import { Component, Input, OnInit } from '@angular/core';
import { routeAnimations } from '../../../core/core.module';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import {
  followUserAction,
  unFollowUserAction
} from '../../state/actions/profile-user.actions';

@Component({
  selector: 'mini-header',
  templateUrl: './mini-header.component.html',
  styleUrls: ['./mini-header.component.scss'],
  animations: [routeAnimations]
})
export class MiniHeaderComponent implements OnInit {
  @Input() profileUser: MiniUserModel;
  @Input() currentUser: MiniUserModel;

  constructor(private store$: Store<fromHome.State>) {}

  ngOnInit() {}

  followUser(): void {
    this.store$.dispatch(
      followUserAction({
        payload: {
          followeeId: this.profileUser?.ID
        }
      })
    );
  }

  unFollowUser(): void {
    this.store$.dispatch(
      unFollowUserAction({
        payload: {
          followeeId: this.profileUser?.ID
        }
      })
    );
  }
}
